import type { ChangeEvent } from 'react';

import Button from '../components/common/Button';
import type { ErrorMessage } from '../helpers/type';
import EmailInputField from './EmailInputField';

interface ForgotPasswordFormProps {
  email: string;
  emailError: ErrorMessage;
  emailBorder: string;
  loading: boolean;
  onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  title: string;
  subtitle: string;
  emailLabel: string;
  submitLabel: string;
}

const ForgotPasswordForm = ({
  email,
  emailError,
  emailBorder,
  loading,
  onInputChange,
  onSubmit,
  title,
  subtitle,
  emailLabel,
  submitLabel,
}: ForgotPasswordFormProps) => (
  <div className="w-full max-w-md py-10">
    <div className="text-center mb-8">
      <div className="flex items-center justify-center mb-4"></div>
      <h2 className="text-3xl font-bold text-gray-900">{title}</h2>
      <p className="text-gray-600 mt-2">{subtitle}</p>
    </div>

    <div role="form" onSubmit={onSubmit} className="space-y-6">
      <EmailInputField
        label={emailLabel}
        value={email}
        error={emailError}
        border={emailBorder}
        onChange={onInputChange}
        errorLink="signup"
      />

      <div>
        <Button
          onClick={onSubmit}
          variant="primary"
          size="lg"
          className="w-full"
          loading={loading}
        >
          {submitLabel}
        </Button>
      </div>
    </div>
  </div>
);

export default ForgotPasswordForm;
